import React from 'react';
import { Link } from 'react-router-dom';
import SPAButton from './SPAButton';
import SPAPageHeader from './SPAPageHeader';

interface SPANotFoundProps {
  homeLabel: string;
  homeTo: string;
}

// The page for a route nothing matches. The legacy mounts route every path under their base to
// the same page (config/routes.rb), so a mistyped URL reaches React rather than a Rails 404.
const SPANotFound = ({ homeLabel, homeTo }: SPANotFoundProps) => {
  // The browser's path, not the router's: on a legacy mount the router's is relative to the base.
  const { pathname } = window.location;

  return (
    <div className="tw-min-h-screen tw-bg-spa-bg tw-text-spa-on-bg">
      <div className="tw-max-w-[1400px] tw-mx-auto tw-px-6 tw-py-4">
        <SPAPageHeader title="Page not found" />
        <p className="tw-mb-5 tw-mt-0 tw-text-sm tw-text-spa-secondary">
          There is nothing at <code className="tw-text-spa-primary">{pathname}</code>.
          Check the address, or head back.
        </p>
        <SPAButton asChild variant="primary">
          <Link to={homeTo}>{homeLabel}</Link>
        </SPAButton>
      </div>
    </div>
  );
};

export default SPANotFound;
